module.exports = __webpack_public_path__ + "4d8f9d4ed246deca98bddaddcd16d274.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/feedbacks/review-3.png
// module id = TVSf
// module chunks = 0